/** @jsx builderX.jsx */
import { builderX, Sprite, Image, MovieClip } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='symbols'>
    <MovieClip name='WILD'>
        <MovieClip name='bg3'>
            <Image position={[-95, -131]} src='wild_x3'/>
            <Image position={[-95, -131]} src='wild_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[0, -104]} src='wild_x4'/>
            <Image position={[0, -104]} src='wild_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[0, -140]} src='wild_x5'/>
            <Image position={[0, -140]} src='wild_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='PICa'>
        <MovieClip name='bg3'>
            <Image position={[-18, -23]} src='pic_a_x3'/>
            <Image position={[-18, -23]} src='pic_a_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -10]} src='pic_a_x4'/>
            <Image position={[-10, -10]} src='pic_a_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -26]} src='pic_a_x5'/>
            <Image position={[-10, -26]} src='pic_a_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='PICb'>
        <MovieClip name='bg3'>
            <Image position={[-13, -12]} src='pic_b_x3'/>
            <Image position={[-13, -12]} src='pic_b_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -10]} src='pic_b_x4'/>
            <Image position={[-10, -10]} src='pic_b_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -10]} src='pic_b_x5'/>
            <Image position={[-10, -10]} src='pic_b_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='PICc'>
        <MovieClip name='bg3'>
            <Image position={[-13, -13]} src='pic_c_x3'/>
            <Image position={[-13, -13]} src='pic_c_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -10]} src='pic_c_x4'/>
            <Image position={[-10, -10]} src='pic_c_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -10]} src='pic_c_x5'/>
            <Image position={[-10, -10]} src='pic_c_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='A'>
        <MovieClip name='bg3'>
            <Image src='a_x3'/>
            <Image src='a_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='a_x4'/>
            <Image src='a_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='a_x5'/>
            <Image src='a_dimmeda_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='K'>
        <MovieClip name='bg3'>
            <Image src='k_x3'/>
            <Image src='k_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='k_x4'/>
            <Image src='k_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='k_x5'/>
            <Image src='k_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='Q'>
        <MovieClip name='bg3'>
            <Image src='q_x3'/>
            <Image src='q_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='q_x4'/>
            <Image src='q_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='q_x5'/>
            <Image src='q_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='J'>
        <MovieClip name='bg3'>
            <Image src='j_x3'/>
            <Image src='j_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='j_x4'/>
            <Image src='j_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='j_x5'/>
            <Image src='j_dimmeda_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='T'>
        <MovieClip name='bg3'>
            <Image src='t_x3'/>
            <Image src='t_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='t_x4'/>
            <Image src='t_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='t_x5'/>
            <Image src='t_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='N'>
        <MovieClip name='bg3'>
            <Image src='n_x3'/>
            <Image src='n_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='n_x4'/>
            <Image src='n_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='n_x5'/>
            <Image src='n_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='Scatter'>
        <MovieClip name='bg3'>
            <Image position={[-10, -30]} src='scatter_x3_en'/>
            <Image position={[-10, -30]} src='scatter_dimmed_x3_en'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -40]} src='scatter_x4_en'/>
            <Image position={[-10, -40]} src='scatter_dimmed_x4_en'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -32]} src='scatter_x5_en'/>
            <Image position={[-10, -32]} src='scatter_dimmed_x5_en'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='Activator'>
        <MovieClip name='bg3'>
            <Image position={[-95, -131]} src='wild_activator_x3'/>
            <Image position={[-95, -131]} src='wild_activator_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[0, -104]} src='wild_activator_x4'/>
            <Image position={[0, -104]} src='wild_activator_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[0, -140]} src='wild_activator_x5'/>
            <Image position={[0, -140]} src='wild_activator_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='PICa2'>
        <MovieClip name='bg3'>
            <Image position={[-18, -23]} src='pic_a_double_x3'/>
            <Image position={[-18, -23]} src='pic_a_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -10]} src='pic_a_double_x4'/>
            <Image position={[-10, -10]} src='pic_a_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -26]} src='pic_a_double_x5'/>
            <Image position={[-10, -26]} src='pic_a_double_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='PICb2'>
        <MovieClip name='bg3'>
            <Image position={[-13, -12]} src='pic_b_double_x3'/>
            <Image position={[-13, -12]} src='pic_b_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -10]} src='pic_b_double_x4'/>
            <Image position={[-10, -10]} src='pic_b_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -10]} src='pic_b_double_x5'/>
            <Image position={[-10, -10]} src='pic_b_double_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='PICc2'>
        <MovieClip name='bg3'>
            <Image position={[-13, -13]} src='pic_c_double_x3'/>
            <Image position={[-13, -13]} src='pic_c_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image position={[-10, -10]} src='pic_c_double_x4'/>
            <Image position={[-10, -10]} src='pic_c_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image position={[-10, -10]} src='pic_c_double_x5'/>
            <Image position={[-10, -10]} src='pic_c_double_dimmed'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='A2'>
        <MovieClip name='bg3'>
            <Image src='a_double_x3'/>
            <Image src='a_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='a_double_x4'/>
            <Image src='a_double_dimmed'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='a_doublea_x5'/>
            <Image src='a_double_dimmeda_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='K2'>
        <MovieClip name='bg3'>
            <Image src='k_double_x3'/>
            <Image src='k_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='k_double_x4'/>
            <Image src='k_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='k_double_x5'/>
            <Image src='k_double_dimmed'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='Q2'>
        <MovieClip name='bg3'>
            <Image src='q_double_x3'/>
            <Image src='q_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='q_double_x4'/>
            <Image src='q_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='q_double_x5'/>
            <Image src='q_double_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='J2'>
        <MovieClip name='bg3'>
            <Image src='j_double_x3'/>
            <Image src='j_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='j_double_x4'/>
            <Image src='j_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='j_doublea_x5'/>
            <Image src='j_double_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='T2'>
        <MovieClip name='bg3'>
            <Image src='t_double_x3'/>
            <Image src='t_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='t_double_x4'/>
            <Image src='t_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='t_double_x5'/>
            <Image src='t_double_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='N2'>
        <MovieClip name='bg3'>
            <Image src='n_double_x3'/>
            <Image src='n_double_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Image src='n_double_x4'/>
            <Image src='n_double_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Image src='n_double_x5'/>
            <Image src='n_double_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
    <MovieClip name='Ruby'>
        <MovieClip name='bg3'>
            <Sprite name='normal'>
                <Image position={[-95, -131]} name='normal' src='wild_x3'/>
                <Image position={[-19, -19]} src='rubycoin_x3'/>
            </Sprite>
            <Image position={[-95, -131]} name='justWild' src='wild_x3'/>
            <Image position={[-95, -131]} name='dimmed' src='wild_dimmed_x3'/>
        </MovieClip>
        <MovieClip name='bg4'>
            <Sprite name='normal'>
                <Image position={[0, -104]} name='normal' src='wild_x4'/>
                <Image position={[0, -56]} src='rubycoin_552x360_x4'/>
            </Sprite>
            <Image position={[0, -104]} name='justWild' src='wild_x4'/>
            <Image position={[0, -104]} name='dimmed' src='wild_dimmed_x4'/>
        </MovieClip>
        <MovieClip name='bg5'>
            <Sprite name='normal'>
                <Image position={[0, -140]} name='normal' src='wild_x5'/>
                <Image position={[0, -66]} src='rubycoin_552x288_x5'/>
            </Sprite>
            <Image position={[0, -140]} name='justWild' src='wild_x5'/>
            <Image position={[0, -140]} name='dimmed' src='wild_dimmed_x5'/>
        </MovieClip>
    </MovieClip>
</Sprite>;
